import { render } from "./ResetPassword.vue?vue&type=template&id=1da614ac"
import script from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPassword.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Auth/ResetPassword.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1da614ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1da614ac', __exports__)) {
    api.reload('1da614ac', __exports__)
  }
  
  module.hot.accept("./ResetPassword.vue?vue&type=template&id=1da614ac", () => {
    api.rerender('1da614ac', render)
  })

}


export default __exports__